import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { useTranslation } from 'react-i18next';
import './serviceCodes.css';

const ServiceCodeData = () => {
  const { t, i18n } = useTranslation();
  const { token } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const serviceCodeId = searchParams.get('id');

  const [formData, setFormData] = useState({
    codeNumber: '',
    codeName: ''
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    if (serviceCodeId) {
      setIsEditMode(true);
      fetchServiceCodeDetails();
    }
  }, [serviceCodeId, token, i18n.language]);

  const fetchServiceCodeDetails = async () => {
    try {
      const response = await fetch('https://naql.nozzm.com/api/service_code_details', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'lang': i18n.language,
        },
        body: JSON.stringify({ id: serviceCodeId }),
      });

      const result = await response.json();
      if (result.status) {
        const serviceCode = result.data;
        setFormData({
          codeNumber: serviceCode.code_number || '',
          codeName: serviceCode.code_name || ''
        });
      } else {
        setError(result.message || 'Failed to fetch service code details');
      }
    } catch (error) {
      setError('Error fetching service code details');
      console.error('Error:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const endpoint = isEditMode ? 'update_service_code' : 'add_service_code';
      const requestData = {
        ...formData,
        ...(isEditMode && { id: serviceCodeId })
      };

      const response = await fetch(`https://naql.nozzm.com/api/${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'lang': i18n.language,
        },
        body: JSON.stringify(requestData),
      });

      const result = await response.json();
      if (result.status) {
        navigate('/ServiceCodes', { state: { updated: true } });
      } else {
        setError(result.message || `Failed to ${isEditMode ? 'update' : 'add'} service code`);
      }
    } catch (error) {
      setError(`Error ${isEditMode ? 'updating' : 'adding'} service code`);
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container tables bg-white mt-5">
      <div className="tableTitle">
        <h3>{isEditMode ? t('serviceCodes.editCode') : t('serviceCodes.addCode')}</h3>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">{t('serviceCodes.codeNumber')}</label>
            <input
              type="text"
              className="form-control"
              name="codeNumber"
              value={formData.codeNumber}
              onChange={handleChange}
              placeholder={t('serviceCodes.codeNumberPlaceholder')}
              required
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">{t('serviceCodes.codeName')}</label>
            <input
              type="text"
              className="form-control"
              name="codeName"
              value={formData.codeName}
              onChange={handleChange}
              placeholder={t('serviceCodes.codeNamePlaceholder')}
              required
            />
          </div>

          <div className="col-12">
            <div className="d-flex gap-2">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? 'جاري الحفظ...' : (isEditMode ? t('update') : t('save'))}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate('/ServiceCodes')}
              >
                {t('cancel')}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ServiceCodeData;
